import React from "react";
import {MuiThemeProvider, createMuiTheme} from "@material-ui/core/styles";
import customBaseTheme from "./customBaseTheme";

const muiTheme = createMuiTheme(customBaseTheme);

export default class ThemeWrapper extends React.Component {
  render() {
    return <MuiThemeProvider theme={muiTheme}>{this.props.children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/themes/ThemeWrapper.js